import {Injectable}                                                from '@angular/core';
import {BehaviorSubject}                                           from 'rxjs';
import {HttpEvent, HttpEventType, HttpProgressEvent, HttpResponse} from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class ApUploadFakeStreamService {
  handler: BehaviorSubject<HttpEvent<any>> = null;

  constructor() {
    this.initHandler();
  }

  initHandler(): void {
    this.handler = new BehaviorSubject<HttpEvent<any>>({
      type: HttpEventType.UploadProgress,
      loaded: 0,
      total: 100
    } as HttpProgressEvent);
  }

  next(event: HttpEvent<any>): void {
    this.handler.next(event);
  }

  finish(): void {
    this.handler.next(new HttpResponse({status: 200}));
    this.initHandler();
  }

  error(): void {
    this.handler.error(new Error('404'));
    this.initHandler();
  }
}
